import {Button, Chip, Typography} from "@material-tailwind/react";
import React, {memo, useContext, useState} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import TableTdContent from "../system/tableTdContent";
import {PaginateContext} from "../../context/paginate";
 

const TABLE_HEAD = ["#", "کاربر", "گرایش", "روز انجام خدمت", "وضعیت", "مبلغ", "استعلام", "پرداخت", "موضوع", "چالش", "گزارش پیشرفت", "عملیات"];

// Helper function to get status label and color
const getServiceStatusDisplay = (status, completed_full_payment) => {
  const statusMap = {
    'new': { label: Dict('new'), color: "indigo" },
    'rejected': { label: Dict('rejected'), color: 'red' },
    'payment': { 
      label: completed_full_payment === false ? Dict('down_payment') : Dict('payment'),
      color: completed_full_payment === false ? 'yellow' : 'green',
    },
    'finish': { label: Dict('finish'), color: 'green' },
  };

  return statusMap[status] || { label: Dict(status), color: 'amber' };
};

function AgentServiceGridComponent({services, onOpenCheck, onOpenReport}) {

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "گرایش": "field_title",
    "روز انجام خدمت": "day",
    "وضعیت": "status",
    "مبلغ": "price",
    "استعلام": "created_at",
    "پرداخت": "paid_at",
    "موضوع": "topic",
    "چالش": "challenge",
    "گزارش پیشرفت": "",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "گرایش": true,
    "روز انجام خدمت": true,
    "وضعیت": true,
    "مبلغ": true,
    "استعلام": true,
    "پرداخت": true,
    "موضوع": true,
    "چالش": true,
    "گزارش پیشرفت": false,
    "عملیات": false,
  }

  return (<div className="w-full border border-blue-gray-100 rounded-xl overflow-hidden [&_button]:min-w-0 [&_button]:px-1 [&_button]:py-2">
    <table className="w-full table-fixed text-left">
      <colgroup>
        <col className="w-[3%]"/>
        <col className="w-[10%]"/>
        <col className="w-[10%]"/>
        <col className="w-[8%]"/>
        <col className="w-[9%]"/>
        <col className="w-[8%]"/>
        <col className="w-[9%]"/>
        <col className="w-[9%]"/>
        <col className="w-[10%]"/>
        <col className="w-[10%]"/>
        <col className="w-[7%]"/>
        <col className="w-[7%]"/>
      </colgroup>
      <TableHead
        tableHead={TABLE_HEAD}
        headSortable={headSortable}
        headMap={headMap}
        sortType={sortType}
        setSortType={setSortType}
        setSortBy={setSortBy}
        selectedHead={selectedHead}
        setSelectedHead={setSelectedHead}
      />
      <tbody className="textCenter divide-y divide-blue-gray-100">
      {services.map(({
                      id,
                      title,
                      person_name,
                      person_family,
                      field_title,
                      branch_title,
                      day,
                      status,
                      price,
                      created_at,
                      paid_at,
                      topic,
                      challenge,
                      completed_full_payment,
                    }, index) => {
        const isLast = index === services.length - 1;
        const classes = isLast ? "p-4" : "p-4";

        return (<tr key={id}>

          <td className={classes}>
            <div className="flex justify-center">
              <Typography color="blue-gray">
                {persianNumberFormat(index + 1, true)}
              </Typography>
            </div>
          </td>

          <td className={`${classes}`}>
            <TableTdContent content={`${person_name} ${person_family}`}/>
          </td>

          <td className={`${classes}`}>
            <TableTdContent content={`${field_title} ${branch_title}`}/>
          </td>

          <td className={classes}>
            <div className="flex justify-center px-2">
              <Typography color="blue-gray" className="textRight break-words">
                {persianNumberFormat(day, true)}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <div className="flex justify-center px-2">
              {(() => {
                const { label, color } = getServiceStatusDisplay(status, completed_full_payment);
                return <Chip variant="ghost" color={color} size="sm" value={label} />;
              })()}
            </div>
          </td>

          <td className={classes}>
            <div className="flex justify-center px-2">
              <Typography color="blue-gray" className="textRight break-words">
                {persianNumberFormat(price, true)}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <div className="flex flex-col justify-center px-2">
              <Typography color="blue-gray" className="break-words">
                {persianNumberFormat(created_at.split(" ")[0])}
              </Typography>
              <Typography color="blue-gray" className="break-words">
                {persianNumberFormat(created_at.split(" ")[1])}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <div className="flex flex-col justify-center px-2">
              <Typography color="blue-gray" className="break-words">
                {persianNumberFormat(paid_at.split(" ")[0])}
              </Typography>
              <Typography color="blue-gray" className="break-words">
                {persianNumberFormat(paid_at.split(" ")[1])}
              </Typography>
            </div>
          </td>

          <td className={classes}>
            <TableTdContent content={topic}/>
          </td>

          <td className={classes}>
            <TableTdContent content={challenge}/>
          </td>

          <td className={classes}>
            <Button variant="text" onClick={() => {
              onOpenReport(services[index]);
            }}
            >
              گزارش پیشرفت
            </Button>
          </td>

          <td className={classes}>
            {status !== "finish" && <Button variant="outlined" onClick={() => {
              onOpenCheck(services[index]);
            }}
            >
              مشاهده/بررسی مدارک
            </Button>}
            {status === "finish" && <Button variant="outlined" onClick={() => {
              onOpenCheck(services[index]);
            }}
            >
              مشاهده
            </Button>}
          </td>
        </tr>);
      },)}
      </tbody>

    </table>
    {services?.length === 0 ??
      <Typography color="gray" className="textCenter">
        تا کنون خدماتی استعلام نشده است!
      </Typography>
    }
  </div>);
}

export const AgentServiceGrid = memo(AgentServiceGridComponent);
